const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || isDev ? 'http://localhost:8080' : 'https://exif.osint-tool.com';
// export const API_BASE_URL = 'http://localhost:8080'

export const INTERESTING_EXIF_SECTIONS = [
    {section: "IPTC", heading: "Copyright Notice"},
    {section: "IPTC", heading: "Special Instructions"},
    {section: "IPTC", heading: "Original Transmission Reference"},
    {section: "IPTC", heading: "By-line"},
    {section: "ICC Profile", heading: "Copyright"},
    {section: "Exif SubIFD", heading: "Body Serial Number"},
    {section: "Exif SubIFD", heading: "Date/Time Original"},
    {section: "Exif SubIFD", heading: "Date/Time Digitized"},
    {section: "Exif IFD0", heading: "Software"},
    {section: "Exif IFD0", heading: "Date/Time"},
    {section: "Exif IFD0", heading: "Make"},
    {section: "Exif IFD0", heading: "Model"},
    {section: "Photoshop", heading: "URL List"},
    {section: "Photoshop", heading: "Version Info"},
    {section: "IPTC", heading: "Date Created"},
    {section: "IPTC", heading: "Time Created"},
    {section: "IPTC", heading: "Digital Date Created"},
    {section: "IPTC", heading: "Caption/Abstract"},
    {section: "Nikon Makernote", heading: "Camera Serial Number"},
    {section: "ICC Profile", heading: "Profile Description"},
    {section: "ICC Profile", heading: "Profile Copyright"},
    {section: "Exif SubIFD", heading: "Lens Model"},
    {section: "Exif SubIFD", heading: "Lens Serial Number"},
    {section: "Apple Makernote", heading: "Acceleration Vector"},
    {section: "Exif SubIFD", heading: "Subject Location"},
    {section: "Exif SubIFD", heading: "Time Zone"},
    {section: "Exif SubIFD", heading: "Lens Specification"},
    {section: "Apple Run Time", heading: "*"},
    {section: "GPS", heading: "*"}
]


// WEBPACK FOOTER //
// ./src/constants/index.js